import CardSearchProduct from "@fdn/card_search_product";
import vars from "Consts/vars";
import handleLoadMoreLabel from "Helpers/loadMore";
import SortSearch from "../../sort/sort";

const Desktop = (props) => {

	const prop = props;

	const limitData = 24;

	return (
		<div className="component-tab-service">
			{
				prop.dataServices?.data?.services.length > 0 ? (
					<>
						<div className="component-tab-service__section-title">
							<p className="component-tab-service__title title-product">Salon & Clinic</p>
							<div className="component-tab-service__button-view-all" type="button">
								<SortSearch isMobile={prop.isMobile} handleSorting={prop.handleSorting} />
							</div>
						</div>
						<div className="component-tab-service__product">

							{
								Array.isArray(prop.dataServices?.data?.services)
								&& prop.dataServices?.data?.services.map((data) => (
									<CardSearchProduct
										key={data?.id}
										isMobile={prop.isMobile}
										maxWidth="300px"
										data={{
											name: data?.name || "-",
											brand: data?.service?.name || "-",
											image: data?.assets[0].url || vars.no_image,
											rating: data?.rating?.rating_overall || 0,
											totalRating: data?.total_review || 0,
											url: Array.isArray(data?.categories)
											&& data?.categories.length > 0
												? `${process.env.NEXT_PUBLIC_REVIEWS_DOMAIN}/services/${data?.categories[0]?.parent?.slug}/
												${data?.categories[0]?.slug}/${data?.brand?.slug}/${data?.slug}`
												: process.env.NEXT_PUBLIC_REVIEWS_DOMAIN,
										}}
									/>

								))
							}
						</div>
						{
							prop.dataServices?.data?.services.length < prop.dataServices?.pagination.total && (
								<div className="component-tab-service__section-more-data">
									<button
										type="button"
										className="component-tab-service__title-more-data"
										onClick={prop.handleLoadMoreServices}
										id="id-loadmore"
									>

										{handleLoadMoreLabel({
											page: prop.dataServices?.pagination.page,
											limit: limitData,
											total: prop.dataServices?.pagination.total,
											data: prop.dataServices?.data?.services,
											text: "Salon & Clinic",
										})}
									</button>
								</div>
							)
						}

					</>
				) : (
					<div className="component-tab-service__section-image-error">
						<img src="https://s3.ap-southeast-1.amazonaws.com/assets.femaledaily.com/error-image/image-no-result.png" alt="page error" className="component-tab-service__image-error" />
						<h4 className="component-tab-service__title">Sorry, no result found</h4>
						<p className="component-tab-service__sub_title">Please try another keyword!</p>
					</div>
				)
			}

			<style jsx>
				{`
						.component-tab-service{
							padding-top: 10px;
							max-width: 1280px;
							margin: auto;
						}
						.component-tab-service__section-title{
							display: flex;
							margin-top: 36px;
							margin-bottom: 22px;
							justify-content: space-between;
						}
						.component-tab-service__title{
							font-family: 'Creato Display';
							font-style: normal;
							font-weight: 700;
							font-size: 16px;
							line-height: 24px;
							color: #13161A;
						}
						.component-tab-service__product{
							display: grid;
  							grid-template-columns: repeat(3, 1fr);
							gap: 12px;
						}
						.component-tab-service__button-view-all{
							font-family: 'Creato Display';
							font-style: normal;
							font-weight: 700;
							font-size: 14px;
							line-height: 22px;
							color: #DB284E;
							background-color: transparent;
							border: none;
						}
						.component-tab-service__section-more-data{
							display: flex;
    						justify-content: center;
							margin-top: 24px;
						}
						.component-tab-service__title-more-data{
							font-family: 'Creato Display', sans-serif;
							font-style: normal;
							font-weight: 700;
							font-size: 16px;
							text-align: center;
							padding: 8px 16px;
							background: #fff;
							border: 1px solid #000;
							border-radius: 8px;
							display: flex;
							justify-content: center;
							align-items: center;
							cursor: pointer;
						}
						.component-tab-service__section-image-error{
							flex-direction: column;
							display: flex;
    						justify-content: center;
							align-items: center;
							padding: 45.5px 0 26px;
						}
						.component-tab-service__image-error{
							width: 200px;
							height: 200px;
							margin-bottom: 24px;

						}
						.component-tab-service__title{
							margin-bottom: 8px;
							font-family: 'Creato Display' !important;
						}
						.component-tab-service__sub_title{
							font-family: 'Creato Display' !important;
						}
					`}
			</style>
		</div>
	);

};

export default Desktop;
